export default __webpack_public_path__ + "static/media/results.e460bfa9.png";